var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6202 5.9563V7.5411C17.6409 7.95931 16.9555 8.92214 16.9555 10.0431C16.9555 11.164 17.6409 12.1268 18.6202 12.545V14.1298C18.6202 15.6345 17.5259 16.6412 15.8618 16.8543C11.2841 17.4406 8.72397 17.4446 4.13824 16.8543C2.52021 16.6461 1.37977 15.6345 1.37977 14.1298V12.5451C2.35928 12.1269 3.04472 11.164 3.04472 10.0431C3.04472 8.92207 2.35928 7.9592 1.37977 7.54102V5.9563C1.37977 4.4516 2.53127 3.50096 4.13824 3.2318C8.66953 2.47282 11.2652 2.58695 15.8618 3.2318C17.3817 3.44504 18.6202 4.4516 18.6202 5.9563Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37483 8.41803C8.09224 8.41803 8.67382 7.83646 8.67382 7.11904C8.67382 6.40163 8.09224 5.82004 7.37483 5.82004C6.65741 5.82004 6.07584 6.40163 6.07584 7.11904C6.07584 7.83646 6.65741 8.41803 7.37483 8.41803Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6796 13.75C13.397 13.75 13.9786 13.1684 13.9786 12.451C13.9786 11.7336 13.397 11.152 12.6796 11.152C11.9622 11.152 11.3806 11.7336 11.3806 12.451C11.3806 13.1684 11.9622 13.75 12.6796 13.75Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95779 12.8136C9.6436 10.6034 10.9857 9.27667 13.0419 6.72954",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerks);
export default __webpack_public_path__ + "static/media/perks.7e4e39aba8cc212e5054993de9163757.svg";
export { ForwardRef as ReactComponent };